<template>
    <div class="switch-buttons-group-button" role="button" :title="helper" :class="{selected}" @click="$emit('select')">
        <FIcon :icon="icon" />
    </div>
</template>

<script>
export default {
    props: {
        icon: String,
        helper: String,
        selected: Boolean
    }
}
</script>

<style lang="scss">
.switch-buttons-group>.switch-buttons-group-button {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    gap: 8px;

    border-radius: 4px;

    transition:  background-color 125ms ease ;

    .f-icon {
        color: var(--primary);
    }

    &:hover {
        background-color: var(--black-a25);
        cursor: pointer;
    }

    &:active {
        background-color: var(--black-a50);
    }

    &.selected {
        border-radius: 4px;
        background-color: var(--Black, #191919);

        /* Drop shadow/Light */
        box-shadow: 0px 4px 16px 0px rgba(22, 22, 21, 0.10);
    }

}
</style>